export default "__VITE_ASSET__DxjpIuf6__"